import {useEffect, useId, useRef} from "react";
import {createPortal} from "react-dom";
import {AlertTriangle, X} from "lucide-react";
import {useTranslation} from "../../../shared/i18n";


export const ConfirmDialog = ({open, title, copy, confirmLabel, cancelLabel, pending, onCancel, onConfirm}) => {
    const {t} = useTranslation();
    const resolvedConfirmLabel = confirmLabel || t("sections.content.p179");
    const resolvedCancelLabel = cancelLabel || t("sections.content.p180");
    const titleId = useId();
    const triggerRef = useRef(null);
    const confirmRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        triggerRef.current = document.activeElement;
        const frame = window.requestAnimationFrame(() => confirmRef.current?.focus());
        const handleKeyDown = (event) => {
            if (event.key === "Escape" && !pending) onCancel();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            window.cancelAnimationFrame(frame);
            document.removeEventListener("keydown", handleKeyDown);
            if (triggerRef.current && document.contains(triggerRef.current)) triggerRef.current.focus();
        };
    }, [onCancel, open, pending]);

    if (!open) return null;

    return createPortal(
        <div className="content-dialog-backdrop" onMouseDown={(event) => {
            if (event.target === event.currentTarget && !pending) onCancel();
        }}>
            <section
                aria-busy={pending}
                aria-labelledby={titleId}
                aria-modal="true"
                className="content-dialog"
                role="dialog"
            >
                <header>
                    <span className="content-dialog-icon"><AlertTriangle size={18} /></span>
                    <div>
                        <h2 id={titleId}>{title}</h2>
                        <p>{copy}</p>
                    </div>
                    <button aria-label={t("sections.content.p181")} disabled={pending} onClick={onCancel} type="button"><X size={17} /></button>
                </header>
                <footer>
                    <button className="admin-button admin-button-secondary" disabled={pending} onClick={onCancel} type="button">
                        {resolvedCancelLabel}
                    </button>
                    <button ref={confirmRef} className="admin-button content-danger-button" disabled={pending} onClick={onConfirm} type="button">
                        {pending ? t("sections.content.p182") : resolvedConfirmLabel}
                    </button>
                </footer>
            </section>
        </div>,
        document.body,
    );
};
